import type { PropsWithChildren, ReactNode } from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { SlideUp } from "@/components/ui/motion";
import { cn } from "@/lib/cn";

interface PanelProps extends PropsWithChildren {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

export function Panel({
  title,
  description,
  actions,
  className,
  children,
}: PanelProps) {
  return (
    <SlideUp>
      <Card className={cn("overflow-hidden", className)} asChild>
        <section>
          <CardHeader className="flex-col sm:flex-row items-start justify-between gap-2 sm:gap-3 space-y-0">
            <div className="space-y-1">
              <CardTitle asChild>
                <h2>{title}</h2>
              </CardTitle>
              {description ? (
                <CardDescription>{description}</CardDescription>
              ) : null}
            </div>
            {actions ? (
              <div className="flex items-center shrink-0">{actions}</div>
            ) : null}
          </CardHeader>
          <CardContent>{children}</CardContent>
        </section>
      </Card>
    </SlideUp>
  );
}
